// Small helpers for reaching the Graph page from anywhere, kept apart from the graph
// itself so importing them doesn't pull Cytoscape into every page.

let pending = null;

/** Open a bundle in the Graph page (it's passed in memory, not in the URL). */
export function handOffBundle(bundle, title) {
  pending = { bundle, title };
  window.location.hash = "#/graph?handoff=1";
}

/** The bundle handed over, once. */
export function takeHandoff() {
  const p = pending;
  pending = null;
  return p;
}

export const graphHash = (key) => `#/graph?open=${encodeURIComponent(key)}`;
export const graphSrcHash = (url) => `#/graph?src=${encodeURIComponent(url)}`;

// A graph's address can also say what was added to it (add=key,key…) and how it's arranged
// (layout=radial…), so a link opens it as it was built.
export const MAX_LINK_ADDS = 40;
export function parseGraphHash(hash = window.location.hash) {
  const [path, query = ""] = hash.replace(/^#\/?/, "").split("?");
  if (path !== "graph") return null;
  const p = new URLSearchParams(query);
  const add = (p.get("add") || "").split(",").map(s => s.trim()).filter(Boolean).slice(0, MAX_LINK_ADDS);
  return { open: p.get("open"), src: p.get("src"), handoff: p.get("handoff"), add, layout: p.get("layout") };
}
